import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const pagesList = [
    "All Products",
    "Clothing",
    "Jewelery",
    "Electronics",
  ];
  const currentYear = new Date().getFullYear();

  const navigate = useNavigate();

  const navigateLinks = (e, data) => {
    e.preventDefault();
    const page = data.toLowerCase();

    if (page.slice(" ").length > 1) {
      navigate(`/${page.replace(" ", "_")}`);
    } else {
      navigate(`/${data.toLowerCase()}`);
    }
  };

  return (
    <footer className="bg-secondary mt-[50px] sm:mt-[100px] shadow-md">
      <div className="container flex flex-col xs:flex-row justify-between gap-6 py-8 px-4 sm:px-8 mx-auto">
        <div className="block w-[80px]">
          <Link to="/">
            <img src="./img/logo.png" alt="logo" />
          </Link>
        </div>
        <nav className="w-full xs:w-96">
          <ul className="flex flex-row flex-wrap">
            {pagesList.length &&
              pagesList.map((page, index) => (
                <li
                  className="w-1/2 py-2 cursor-pointer hover:underline"
                  onClick={(e) => navigateLinks(e, page)}
                  key={index}
                >
                  {page}
                </li>
              ))}
          </ul>
        </nav>
      </div>
      <div className="text-xs text-center italic py-4 border-t-[1px]">
        © {currentYear}{" "}
        <a
          className="underline"
          href="https://www.udtlakshan.com"
          target="_blank"
        >
          Tharindu Lakshan
        </a>
        . All right reserved.
      </div>
    </footer>
  );
};

export default Footer;
